// withCommas and ...
import "@/extends/extendedPrototypes"

import * as React from "react"

import { Navigate, Route, Routes, json, useLocation } from "react-router-dom"
import {
  actionAuthSetLoading,
  actionAuthSetLoadingOff,
  actionSetLogout,
  // actionSetScore,
  actionSetUser,
  actionUpdateUserInfo,
} from "@/store/slices/auth"
import { api, getEndpoint } from "@/api"

import { IResponseForFetchEntity } from "@/api/types"
import { IUser } from "@/types/user"
import LazyRoute from "./lazy"
import { getUrlWithQueryParams } from "@/utils"
import routes from "./routes"
import { useAuth } from "@/hook"
import { useDispatch } from "react-redux"
import { actionSetScore, actionSetUserScores } from "@/store/slices/scores"
import useScores from "@/hook/useScores"
// import { actionSetLoading, actionSetScore, actionSetScoreError, actionSetScoreLoadingOff } from "@/store/slices/score"

//Panel page
const DashboardPage = React.lazy(() => import("@/components/pages/dashboard"))
//Transaction Page
const TransactionPage = React.lazy(
  () => import("@/components/pages/transaction")
)
// My Properties Page
const MyPropertiesPage = React.lazy(
  () => import("@/components/pages/dashboard/my-properties")
)

//scores table
const ScoresTable = React.lazy(
  () => import("@/components/pages/customer-club/score-table")
)

//my score table
const MyScores = React.lazy(
  () => import("@/components/pages/customer-club/my-scores")
)
//my score table
const ScoreMarket = React.lazy(
  () => import("@/components/pages/customer-club/score-market")
)

const MyProduct = React.lazy(
  () => import("@/components/pages/customer-club/my-products")
)

//Profile page
const ProfilePage = React.lazy(
  () => import("@/components/pages/dashboard/profile")
)

//Panel page
const DashboardWrapper = React.lazy(
  () => import("@/containers/dashboard-wrapper")
)
//Properties page
const PropertiesPage = React.lazy(
  () => import("@/components/pages/dashboard/properties")
)
//Add Property Page
const AddPropertyPage = React.lazy(
  () => import("@/components/shared/add-property")
)
const SingleProperty = React.lazy(
  () => import("@/components/pages/dashboard/single-property")
)

//Tickets page
const TicketsHolder = React.lazy(
  () => import("@/components/pages/dashboard/tickets")
)
const CreateTicket = React.lazy(
  () => import("@/components/pages/dashboard/tickets/create")
)

//Add Financial Page
const FinancialPage = React.lazy(
  () => import("@/components/pages/dashboard/financial")
)
//Notifications page
const Notifications = React.lazy(
  () => import("@/components/pages/dashboard/notifications")
)
//single ticket view
const ShowSingleTicket = React.lazy(
  () => import("@/components/pages/dashboard/tickets/show")
)

const NotFoundPage = React.lazy(
  () => import("@/components/shared/not-found-page")
)

const RouteElements = () => {
  const { isLoggedIn, user } = useAuth()

  const dispatcher = useDispatch()

  const { getUserScore } = useScores()

  // const getUserProfile = async () => {
  //   if (!isLoggedIn) return

  //   //Showing loading
  //   dispatcher(actionAuthSetLoading)
  //   try {
  //     const res = await api.get<IResponseForFetchEntity<IUser>>(
  //       getUrlWithQueryParams(getEndpoint("profile"), {
  //         expand: "media,roles",
  //       })
  //     )
  //     const userProfile = res?.data?.data?.item || null
  //     dispatcher(actionSetUser({ user: userProfile }))
  //     dispatcher(actionUpdateUserInfo(userProfile))
  //   } catch (e) {
  //     //Loggin out user
  //     dispatcher(actionSetLogout)
  //   } finally {
  //     //Disableing loading
  //     dispatcher(actionAuthSetLoadingOff)
  //   }
  // }

  // const getUserScores = async () => {
  //   if (!isLoggedIn) return
  //   try {
  //     const res = await api.get(getEndpoint("myScores")
  //     )
  //     const userScores = res?.data?.scores || []

  //     dispatcher(actionSetUserScores(userScores))

  //     const total = userScores
  //       .filter((score: any) => score.is_claimed)
  //       .reduce((sum: number, score: any) => sum + parseFloat(score.score), 0);
  //     dispatcher(actionSetScore(total))
  //   } catch (e) {
  //     //Loggin out user

  //   } finally {
  //     //Disableing loading

  //   }
  // }

  //deconstract route names from routes
  const {
    dashboard,
    index,
    properties,
    notifications,
    profile,
    financial,
    tickets,
    transaction,
    customerClub
  } = routes

  return (
    <Routes>
      <Route
        index
        element={<LazyRoute element={<Navigate to={`${dashboard.index}`} />} />}
      />
      <Route
        path={transaction.index}
        element={<LazyRoute element={<TransactionPage />} />}
      />
      <Route
        path={index}
        element={
          <LazyRoute
            element={<DashboardWrapper />}
          />
        }
      >
        <Route path={dashboard.index}>
          <Route index element={<LazyRoute element={<DashboardPage />} />} />
        </Route>
        <Route path={properties.index}>
          <Route index element={<LazyRoute element={<PropertiesPage />} />} />
          <Route
            path={properties.add}
            element={<LazyRoute element={<AddPropertyPage />} />}
          />
          <Route path={properties["my-properties"].index}>
            <Route
              index
              element={<LazyRoute element={<MyPropertiesPage />} />}
            />
          </Route>
          <Route
            path={properties.show}
            element={<LazyRoute element={<SingleProperty />} />}
          />
        </Route>
        <Route
          path={profile.index}
          element={<LazyRoute element={<ProfilePage />} />}
        />
        <Route path={tickets.index}>
          <Route index element={<LazyRoute element={<TicketsHolder />} />} />
          <Route
            path={tickets.add}
            element={<LazyRoute element={<CreateTicket />} />}
          />
          <Route
            path={tickets.show}
            element={<LazyRoute element={<ShowSingleTicket />} />}
          />
        </Route>
        <Route path={notifications.index}>
          <Route index element={<LazyRoute element={<Notifications />} />} />
        </Route>
        <Route
          path={financial.index}
          element={<LazyRoute element={<FinancialPage />} />}
        />
        <Route>

        </Route>
        {process.env.REACT_APP_CUSTOMER_CLUB === "true" && <>
        <Route
          path={customerClub.scorestable}
          element={<LazyRoute element={<ScoresTable />} />}

        />
        <Route
          path={customerClub.myscore}
          element={<LazyRoute element={<MyScores />} />}

        />
        <Route
          path={customerClub.myproduct}
          element={<LazyRoute element={<MyProduct />} />}

        />
        <Route
          path={customerClub.scoremarket}
          element={<LazyRoute element={<ScoreMarket />} />}

        />
      </>}
      </Route>
      <Route path="/404" element={<LazyRoute element={<NotFoundPage />} />} />
      <Route path="*" element={<Navigate to={"/404"} replace />} />
    </Routes>
  )
}

export default RouteElements
